import { IconProps } from '../../../lib/types';

const DollarSign: React.FC<IconProps> = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="9.963"
      height="17.71"
      viewBox="0 0 9.963 17.71"
      className={className}
    >
      <path
        className="a"
        d="M7.316,8.374,3.293,7.226A1.471,1.471,0,0,1,2.217,6.067a1.42,1.42,0,0,1,1.4-1.64H6.171a2.674,2.674,0,0,1,1.536.488.551.551,0,0,0,.709-.059l.792-.792a.56.56,0,0,0-.052-.834A4.852,4.852,0,0,0,6.171,2.214h-.1V.553A.555.555,0,0,0,5.521,0H4.414A.555.555,0,0,0,3.86.553v1.66H3.774A3.749,3.749,0,0,0,.093,4.967,3.641,3.641,0,0,0,2.619,9.336l4.023,1.148a1.471,1.471,0,0,1,1.076,1.159,1.42,1.42,0,0,1-1.4,1.64H3.763A2.674,2.674,0,0,1,2.228,12.8a.551.551,0,0,0-.709.059l-.792.792a.56.56,0,0,0,.052.834A4.837,4.837,0,0,0,3.763,15.5h.1v1.66a.555.555,0,0,0,.553.553H5.521a.555.555,0,0,0,.553-.553V15.5h.086a3.749,3.749,0,0,0,3.68-2.753A3.641,3.641,0,0,0,7.316,8.374Z"
        transform="translate(0.014)"
      />
    </svg>
  );
};

export default DollarSign;
